'use client'

import { useState, useEffect } from 'react'

// The window's size, or 0 x 0 where there is no window (the server render).
export const readScreenSize = () =>
  typeof window === 'undefined'
    ? { width: 0, height: 0 }
    : { width: window.innerWidth, height: window.innerHeight }

// Both hooks run on every render (plan step W1): the server case used to return before them,
// which breaks the rules of hooks. useState's initialiser gives the server the same 0 x 0 as before.
const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState(readScreenSize)

  useEffect(() => {
    const handleResize = () => {
      setScreenSize(readScreenSize())
    }

    window.addEventListener('resize', handleResize)

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return screenSize
}

export default useScreenSize
